export default {
  "EmptyTable": "_EmptyTable_11w59_1",
  "Table": "_Table_11w59_14",
  "Head": "_Head_11w59_22",
  "Th": "_Th_11w59_70"
};import "ni:sha-256;-ipY64nEEd43bR58enURbCdfPKrHWTH86MGyJW5m-9U";